if (!customElements.get('video-sound-button')) {
    customElements.define(
        'video-sound-button',
        class VideoSoundButton extends HTMLElement {
            funcOnResize = this.onResize.bind(this)
            constructor() {
                super()
                this.init()
            }
            connectedCallback() {
                console.log(this.dataset.videoid);
                addEventListener("resize", this.funcOnResize)
            }

            disconnectedCallback() {
                this.removeEventListener("resize", this.funcOnResize)
            }
            onResize() {
                let videoID = this.dataset.videoid
                var videos = document.getElementsByClassName(videoID);
                for (let index = 0; index < videos.length; index++) {
                    const element = videos[index];
                    if (element.checkVisibility()) {
                        if (element.paused) {
                            element.load();
                        }
                    } else {
                        if (element.paused == false) {
                            element.pause();
                        }
                    }
                }
            }
            init() {

                let videoID = this.dataset.videoid
                var videos = document.getElementsByClassName(videoID);
                console.log(videos);

                for (let index = 0; index < videos.length; index++) {
                    const element = videos[index];
                    element.addEventListener("visibilitychange", (event) => {
                        console.log("visibilitychange", element, event);

                    })
                }
            }
        }
    );
}

function unmuteVideo(videoID) {
    // var video = document.getElementById(videoID);
    // var img = document.getElementById("img-btn-" + videoID);
    // if (video && img) {
    //     if (video.muted) {
    //         video.muted = false;
    //         img.src = img.dataset.imgunmute

    //     } else {
    //         video.muted = true;
    //         img.src = img.dataset.imgmute
    //     }
    // }

    var videos = document.getElementsByClassName(videoID);
    var img = document.getElementById("img-btn-" + videoID);
    if (videos && img) {
        for (let index = 0; index < videos.length; index++) {
            const video = videos[index];
            if (video.muted) {
                video.muted = false;
                img.src = img.dataset.imgunmute
            } else {
                video.muted = true;
                img.src = img.dataset.imgmute
            }
        }

    }


}